import { faImages } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule, Link } from '@domain-group/suit-theme'

import { useNumericParams } from '@domain-group/react-hooks'

import useCampaign from '@hooks/useCampaign'
import useCurrentUser from '@hooks/useCurrentUser'
import useImages from '@hooks/useImages'

import EnabledPermission from '@components/EnabledPermission'

import { getCampaignPermissions, getCampaignType } from '@functions/campaign'

import ImageGridContainer from './ImageGridContainer'
import MediaImageUrl from './assets/media.svg'

export const icon = faImages

export const configOptions = () => ({
  title: {
    component: 'input',
    key: 'title',
    label: 'Title',
    optionKey: 'customization',
  },
  limit: {
    component: 'select',
    key: 'limit',
    label: 'Limit',
    optionKey: 'queryParams',
    values: [
      { key: 5, label: '5' },
      { key: 10, label: '10' },
      { key: 25, label: '25' },
      { key: 50, label: '50' },
    ],
  },
})

interface ImagesProps {
  customOptions: {
    queryParams: {
      limit?: number,
    },
    customization: {
      title?: string,
    },
  },
}

const Images = (props: ImagesProps) => {
  const {
    customOptions,
    customOptions: {
      queryParams: filters,
    },
  } = props

  const { customization } = customOptions
  const { title } = customization || {}

  const { campaignId } = useNumericParams()

  const {
    campaign,
    campaign: { cache_key: campaignCacheKey },
    urls: {
      campaignMediaUrl,
    },
  } = useCampaign({ id: campaignId })

  const { currentUser } = useCurrentUser()
  const campaignPermissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })

  const { photos_and_plans } = campaignPermissions

  const imagesPayload = useImages({
    filters: {
      hidden: 'false',
      imageable_id: campaignId,
      imageable_type: 'Campaign',
      ...filters,
    },
    performHttpRequests: !!campaignCacheKey,
  })
  const { filteredImages, hasFilteredImages, loading } = imagesPayload

  const imagesArray = filteredImages.slice(0, customOptions.queryParams?.limit || 5)

  return (
    <DashboardModule
      headerRight={!!photos_and_plans?.manage && (
        <EnabledPermission permissionKey="campaign.media.manage" campaignType={getCampaignType(campaign)}>
          <Link href={campaignMediaUrl} textProps={{ fontSize: 'small' }}>
            Manage
          </Link>
        </EnabledPermission>
      )}
      loading={loading}
      title={title || 'Images'}
    >
      {!loading && !hasFilteredImages && (
        <DashboardModule.BlankState imageUrl={MediaImageUrl}>
          <DashboardModule.BlankState.Title>
            No media in this campaign
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            You can upload media in the Photos and Plans page, or order media and have your provider upload for you.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasFilteredImages && (
        <ImageGridContainer images={imagesArray} />
      )}
    </DashboardModule>
  )
}

export default Images
